export enum ETrustpilotFeedbackStep {
  RATING = 'RATING',
  FEEDBACK = 'FEEDBACK',
  TRUSTPILOT = 'TRUSTPILOT',
}

export type TTrustpilotFeedbackModalProps = {
  isOpen: boolean;
  onClose: () => void;
  placement?: string;
  day?: number;
};
